export const isValidE164 = (value) =>
  !!value && /^\+[1-9][0-9]{6,14}$/.test(String(value).trim());
